.card {
  background: var(--bg-surface);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  padding: 1.3rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: var(--shadow-card);
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.85rem;
}

.titleGroup {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.subtitle {
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  font-size: 0.76rem;
  color: var(--text-secondary);
}

.legendItem {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.swatchActual {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background: var(--accent-primary);
}

.swatchIdeal {
  width: 12px;
  height: 3px;
  background: var(--accent-info);
}

.swatchCap {
  width: 12px;
  height: 3px;
  background: var(--status-danger);
}

.chartWrap {
  width: 100%;
  overflow-x: auto;
}

.svgChart {
  width: 100%;
  height: auto;
  min-width: 580px;
  display: block;
}

.inspectorBar {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-radius: var(--radius-md);
  background: var(--bg-surface-elevated);
  border: 1px solid var(--border-subtle);
  font-size: 0.79rem;
  font-variant-numeric: tabular-nums;
}

.inspectorCell {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.inspectorLabel {
  font-size: 0.7rem;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.inspectorValue {
  font-family: var(--font-mono);
  font-weight: 600;
  color: var(--text-primary);
}

@media (max-width: 760px) {
  .inspectorBar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
